import { uuidModule } from "@/modules/uuid";
import { BaseSyncOperation } from "@/store/sync/operations/BaseSyncOperation";
import { OptimisticSyncUpdate, SyncModelData, SyncOperationKind } from "@/store/sync/types";
import { SourceDeletedSyncUpdateValue } from "@/store/sources/types";
import { IDeleteSourceOperation } from "@/store/sync/operations/types";

export class DeleteSourceOperation extends BaseSyncOperation<IDeleteSourceOperation> {
  get operationKind(): SyncOperationKind {
    return "DELETE_SOURCE";
  }

  async generateOptimisticUpdates(): Promise<OptimisticSyncUpdate<SyncModelData>[]> {
    const sourceId = this.payload.source_id;
    if (!sourceId) return [];

    const existingSource = await this.store.sources.getAsync(sourceId);
    if (!existingSource) return [];

    const deletedValue: SourceDeletedSyncUpdateValue = {
      model_id: sourceId,
      model_kind: "SOURCE",
      model_version: existingSource.modelVersion,
    };

    return [
      {
        optimistic_update_id: uuidModule.generate(),
        locally_committed_at: this.committedAt,
        kind: "DELETED",
        value: deletedValue,
      },
    ];
  }

  async triggerRecompute(): Promise<void> {
    const sourceId = this.payload.source_id;
    if (!sourceId) return;
    await this.store.sources.recompute(sourceId);
  }
}
